export enum ActivityAge {
    LESS_1_YEAR = '1C',
    BETWEEN_1_5_YEARS = '2C',
    BETWEEN_5_10_YEARS = '3C',
    MORE_10_YEARS = '4C',
}
